// extracted by mini-css-extract-plugin
export default {"blockUnitCode":"block-unit-code_blockUnitCode__9bGiL"};